import { render, staticRenderFns } from "./DialogTabs.vue?vue&type=template&id=03d939f0&scoped=true"
import script from "./DialogTabs.vue?vue&type=script&lang=js"
export * from "./DialogTabs.vue?vue&type=script&lang=js"
import style0 from "./DialogTabs.vue?vue&type=style&index=0&id=03d939f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d939f0",
  null
  
)

export default component.exports